import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Margin, Panel, Text, Table } from 'shared/components'
import { EventsFilters } from './components/filters'
import { MobileInwinsLayout } from './components/mobileInwinsLayout'

const InwinsComponent = ({
  loadBets,
  columns,
  onSearch,
  loadBeneficiariesFromInwins,
  followerService,
}) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      // Show mobile layout for devices up to 767px (phones)
      setIsMobile(window.innerWidth <= 767)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  // Render mobile layout for mobile devices
  if (isMobile) {
    return (
      <MobileInwinsLayout
        loadBets={loadBets}
        loadBeneficiariesFromInwins={loadBeneficiariesFromInwins}
        followerService={followerService}
      />
    )
  }

  // Render desktop layout for larger screens
  return (
    <Panel>
      <Grid>
        <Row>
          <Col lg={3} xs={12}>
            <Margin top={1} bottom={2}>
              <Text size={18} bold white>
                History of InWins
              </Text>
            </Margin>
          </Col>
          <Col lg={9} xs={12}>
            <EventsFilters debounce={250} onSearch={onSearch} />
          </Col>
        </Row>
      </Grid>
      <Table id="inwins-table" columns={columns} loadData={loadBets} />
    </Panel>
  )
}

InwinsComponent.propTypes = {
  loadBets: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  onSearch: PropTypes.func.isRequired,
  loadBeneficiariesFromInwins: PropTypes.func.isRequired,
  followerService: PropTypes.object.isRequired,
}

export default InwinsComponent
